<div *ngIf="isLoggedIn; else notLoggedIn">
	<div class="toolbar" > <!-- *ngIf="isLoggedIn" -->
		<app-toolbar/>
	</div>
	<mat-drawer-container autosize class="heightContend">
		<mat-drawer class="menu" #drawer mode="side" > <!-- *ngIf="isLoggedIn"-->
			<app-menu/>
		</mat-drawer>
		<div class ="card_ heightContendNA">
	    	<router-outlet />
	  	</div>
	</mat-drawer-container>
</div>
<ng-template #notLoggedIn>
	<router-outlet />
</ng-template>